// Logo component
import { cn } from '@utils/classNames';
import { APP_NAME } from '@config/constants';

interface LogoProps {
  className?: string;
  showSubtext?: boolean;
  size?: 'small' | 'medium' | 'large';
  variant?: 'full' | 'icon';
}

const LOGO_FULL_PATH = '/LogoWS.png';
const LOGO_ICON_PATH = '/logo-icon.png?v=3';

export const Logo: React.FC<LogoProps> = ({
  className,
  showSubtext = true,
  size = 'large',
  variant = 'full',
}) => {
  const USE_IMAGE_LOGO = true;

  const sizeClasses = {
    small: 'h-8',
    medium: 'h-12',
    large: 'h-16',
  };

  const iconSizeClasses = {
    small: 'h-8 w-8',
    medium: 'h-9 w-9',
    large: 'h-11 w-11',
  };

  if (USE_IMAGE_LOGO) {
    const isIcon = variant === 'icon';
    return (
      <div
        className={cn(
          'flex flex-col items-center bg-transparent',
          isIcon && 'items-center justify-center',
          className
        )}
      >
        <img
          src={isIcon ? LOGO_ICON_PATH : LOGO_FULL_PATH}
          alt={APP_NAME}
          className={cn(
            'object-contain bg-transparent',
            isIcon && 'mix-blend-screen',
            isIcon ? iconSizeClasses[size] : sizeClasses[size]
          )}
        />
        {showSubtext && !isIcon && (
          <p className="mt-2 font-inter text-xs text-primary/70 text-center">
            Producer Cloud
          </p>
        )}
      </div>
    );
  }

  const textSizes = {
    small: 'text-2xl',
    medium: 'text-4xl',
    large: 'text-[64px]',
  };

  return (
    <div className={cn('flex flex-col items-center', className)}>
      <h1
        className={cn(
          'font-inter font-bold text-primary text-center tracking-tight drop-shadow-lg',
          textSizes[size]
        )}
      >
        {APP_NAME}
      </h1>
      {showSubtext && (
        <p className="mt-2 font-inter text-xs text-primary/70 text-center">
          Producer Cloud · est. 2025
        </p>
      )}
    </div>
  );
};
